var path = 'shared/expandButton/expandButton.tpl.html';
var html = "<i\n  class=\"glyphicon\"\n  ng-class=\"{\n    'glyphicon-menu-down': expanded,\n    'glyphicon-menu-right': !expanded\n  }\"\n  role=\"button\"\n></i>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;